import { render } from "./TempPiv.vue?vue&type=template&id=20ecd876&scoped=true"
import script from "./TempPiv.vue?vue&type=script&lang=js"
export * from "./TempPiv.vue?vue&type=script&lang=js"

import "./TempPiv.vue?vue&type=style&index=0&id=20ecd876&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ecd876"]])

export default __exports__